import React from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap';
import './Shopping.css'
import { useNavigate } from 'react-router-dom';
import ShopHeader from './ShopHeader';

const Shopping = () => {

    const navigate = useNavigate();

    const food = () => {
        navigate('/food')
    }
    const items = () => {
        navigate('/items')
    }
    const plants = () => {
        navigate('/plants')
    }
    return (
        <>
            <ShopHeader />
            <i><h1 className='h1t'>CATEGORIES</h1></i>
            <div className='row'>
                <div class="card cardstyle">
                    <img class="card-img-top mt-2" src="https://images.unsplash.com/photo-1551963831-b3b1ca40c98e" alt="Card  cap" />
                    <div class="card-body">
                        <h5 class="card-title">FOOD</h5>
                        <button onClick={food} class="btn btn-primary">See All</button>
                    </div>
                </div>
                <div class="card cardstyle">
                    <img class="card-img-top mt-2" src="https://images.unsplash.com/photo-1533827432537-70133748f5c8" alt="Card  cap" />
                    <div class="card-body">
                        <h5 class="card-title">ITEMS</h5>
                        <button onClick={items} class="btn btn-primary">See All</button>
                    </div>
                </div>
                <div class="card cardstyle">
                    <img class="card-img-top mt-2" src="https://images.unsplash.com/photo-1597645587822-e99fa5d45d25" alt="Card  cap" />
                    <div class="card-body">
                        <h5 class="card-title">PLANTS</h5>
                        <button onClick={plants} class="btn btn-primary">See All</button>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Shopping;